const MS_PER_DAY = 24 * 60 * 60 * 1000;
export function allDayCalendarDays(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startUTC = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
  const endUTC = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
  return Math.max(1, Math.round((endUTC - startUTC) / MS_PER_DAY));
}
export function allDayInclusiveEndUTC(endDate) {
  const end = new Date(endDate);
  return new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate() - 1));
}
export function allDayDateToUTCMidnight(dateStr) {
  const [year, month, day] = dateStr.substring(0, 10).split('-').map(Number);
  return Date.UTC(year, month - 1, day);
}
//# sourceMappingURL=index.js.map